import React from 'react';

// Responsive 2-column row for related fields (e.g. origin/destination,
// date/move size). Collapses to a single column on narrow viewports.
export default function MovdFormRow({ columns = 2, children, style }) {
  return (
    <div
      style={{
        display: 'grid',
        gap: 16,
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        ...style,
      }}
      className="movd-form-row"
    >
      <style>{`@media (max-width: 640px) { .movd-form-row { grid-template-columns: 1fr !important; } }`}</style>
      {children}
    </div>
  );
}
